import { render, staticRenderFns } from "./NewCompensationComponente.vue?vue&type=template&id=85824bd4&scoped=true&class=h-100"
import script from "./NewCompensationComponente.vue?vue&type=script&lang=js"
export * from "./NewCompensationComponente.vue?vue&type=script&lang=js"
import style0 from "./NewCompensationComponente.vue?vue&type=style&index=0&id=85824bd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85824bd4",
  null
  
)

export default component.exports